import {
	CAR_CHECKIN_ZONE_TOP_OFFSET_PCT,
	CAR_LOG_CHECKIN_LABEL_ANCHOR_LEFT_PCT,
	CAR_LOG_CHECKIN_LABEL_ANCHOR_RIGHT_PCT,
	CAR_LOG_CHECKIN_LABEL_RISE_REM,
	CAR_LOG_CHECKIN_MARKER_SHIFT_Y_REM,
	CAR_LOG_CHECKIN_LABEL_ZONE_REM,
	CAR_LOG_CHECKIN_LINE_INSIDE_LEFT_REM,
	CAR_LOG_CHECKIN_LINE_INSIDE_RIGHT_REM,
	CAR_SEAL_ZONE_DEBUG_BG,
	CAR_LOG_CHECKIN_ZONE_DEFAULT
} from '../api/config.js'
import {
	applyStyleToElement,
	getCarvueAdjustedZoneAnchor,
	getCarvueFullWidthSquareZoneStyle
} from './act004-hotspot-style.js'
import { cvQuery } from './dom.js'
import { isAct004LinkCheckinZoneHotspot } from '../../../utils/act004-link-checkin-zone.js'

function parsePageConfig(activity) {
	if (!activity) return {}
	let raw = activity.pageConfigJson != null ? activity.pageConfigJson : activity.pageConfig
	if (typeof raw === 'string') {
		try {
			raw = JSON.parse(raw)
		} catch (e) {
			raw = {}
		}
	}
	return raw && typeof raw === 'object' ? raw : {}
}

function findLogCheckinPage(activity) {
	const pageConfig = parsePageConfig(activity)
	const pages = Array.isArray(pageConfig.pages) ? pageConfig.pages : []
	var i
	for (i = 0; i < pages.length; i++) {
		if (String((pages[i] && pages[i].pageName) || '').trim() === '互动打卡') {
			return pages[i]
		}
	}
	return pages.length ? pages[0] : null
}

/** 优先活动配置 type=22 联动热区，否则用设计稿默认中心区域 */
export function resolveLogCheckinZoneAnchor(activity) {
	const pageConfig = parsePageConfig(activity)
	const page = findLogCheckinPage(activity)
	if (page && Array.isArray(page.hotspots)) {
		for (let i = 0; i < page.hotspots.length; i++) {
			if (isAct004LinkCheckinZoneHotspot(page.hotspots[i])) {
				return page.hotspots[i]
			}
		}
	}
	const pages = Array.isArray(pageConfig.pages) ? pageConfig.pages : []
	for (let p = 0; p < pages.length; p++) {
		const list = pages[p] && Array.isArray(pages[p].hotspots) ? pages[p].hotspots : []
		for (let i = 0; i < list.length; i++) {
			if (isAct004LinkCheckinZoneHotspot(list[i])) {
				return list[i]
			}
		}
	}
	return CAR_LOG_CHECKIN_ZONE_DEFAULT
}

function getLogSlideLayoutMetrics() {
	const slide = cvQuery('.swiper-slide.log_slide')
	const div = cvQuery('.log_slide_div')
	if (!slide || !div) return null
	const slideRect = slide.getBoundingClientRect()
	const divRect = div.getBoundingClientRect()
	const slideH = slideRect.height
	const divH = divRect.height
	if (!slideH || !divH) return null
	return {
		slideH: slideH,
		divTopInSlide: divRect.top - slideRect.top,
		divH: divH
	}
}

function applyMapStageMarkerVars(stage) {
	if (!stage) return
	stage.style.setProperty('--log-checkin-label-zone-h', CAR_LOG_CHECKIN_LABEL_ZONE_REM + 'rem')
	stage.style.setProperty('--log-checkin-label-rise', CAR_LOG_CHECKIN_LABEL_RISE_REM + 'rem')
	stage.style.setProperty('--log-checkin-marker-shift-y', CAR_LOG_CHECKIN_MARKER_SHIFT_Y_REM + 'rem')
	stage.style.setProperty('--log-checkin-label-anchor-left', CAR_LOG_CHECKIN_LABEL_ANCHOR_LEFT_PCT + '%')
	stage.style.setProperty('--log-checkin-label-anchor-right', CAR_LOG_CHECKIN_LABEL_ANCHOR_RIGHT_PCT + '%')
	stage.style.setProperty('--log-checkin-line-left', CAR_LOG_CHECKIN_LINE_INSIDE_LEFT_REM + 'rem')
	stage.style.setProperty('--log-checkin-line-right', CAR_LOG_CHECKIN_LINE_INSIDE_RIGHT_REM + 'rem')
}

/** 同步地图内打卡区 CSS 变量（与 dakatu 图绑定） */
export function syncLogCheckinMarkersLayout() {
	const stage = cvQuery('.log_slide_map_stage')
	if (!stage) return
	applyMapStageMarkerVars(stage)
}

export function applyLogCheckinVerifyLayout() {
	const zone = cvQuery('.log_checkin_verify_zone')
	if (!zone) return
	const activity = window.__carActivityDetail
	const anchor = resolveLogCheckinZoneAnchor(activity)
	const adjusted = getCarvueAdjustedZoneAnchor(
		anchor,
		CAR_LOG_CHECKIN_ZONE_DEFAULT.top,
		CAR_CHECKIN_ZONE_TOP_OFFSET_PCT
	)
	const metrics = getLogSlideLayoutMetrics()
	const slideH = metrics ? metrics.slideH : 0
	const boxStyle = getCarvueFullWidthSquareZoneStyle(adjusted, slideH, {
		opacity: '1',
		background: CAR_SEAL_ZONE_DEBUG_BG,
		touchAction: 'none',
		pointerEvents: 'auto',
		zIndex: '11'
	})
	applyStyleToElement(zone, boxStyle)

	const canvas = cvQuery('.checkinCanvas1')
	if (canvas) {
		applyStyleToElement(canvas, {
			position: 'absolute',
			left: '0',
			top: '0',
			width: '100%',
			height: '100%',
			maxWidth: 'none',
			aspectRatio: 'unset',
			zIndex: '12',
			opacity: '0',
			touchAction: 'none'
		})
	}

	syncLogCheckinMarkersLayout()
	bindLogCheckinMapLoad()
	bindLogCheckinMapStageResize()
}

let resizeHandler = null
let vvHandler = null
let mapLoadBound = false
let mapStageResizeObserver = null

function scheduleLogCheckinLayout() {
	if (typeof window === 'undefined') return
	const run = function () {
		applyLogCheckinVerifyLayout()
	}
	if (window.requestAnimationFrame) {
		window.requestAnimationFrame(run)
	} else {
		run()
	}
}

function bindLogCheckinMapLoad() {
	if (mapLoadBound || typeof window === 'undefined') return
	const mapImg = cvQuery('.log_slide_map_img')
	if (!mapImg) return
	mapLoadBound = true
	mapImg.addEventListener('load', scheduleLogCheckinLayout, { passive: true })
	if (mapImg.complete && mapImg.naturalWidth) {
		scheduleLogCheckinLayout()
	}
}

function bindLogCheckinMapStageResize() {
	if (mapStageResizeObserver || typeof window === 'undefined') return
	const stage = cvQuery('.log_slide_map_stage')
	if (!stage || typeof ResizeObserver === 'undefined') return
	mapStageResizeObserver = new ResizeObserver(function () {
		syncLogCheckinMarkersLayout()
	})
	mapStageResizeObserver.observe(stage)
}

export function bindLogCheckinVerifyResize() {
	if (resizeHandler || typeof window === 'undefined') return
	resizeHandler = scheduleLogCheckinLayout
	window.addEventListener('resize', resizeHandler, { passive: true })
	window.addEventListener('orientationchange', resizeHandler, { passive: true })
	const vv = window.visualViewport
	if (vv) {
		vvHandler = resizeHandler
		vv.addEventListener('resize', vvHandler, { passive: true })
		vv.addEventListener('scroll', vvHandler, { passive: true })
	}
	bindLogCheckinMapLoad()
	bindLogCheckinMapStageResize()
}

export function unbindLogCheckinVerifyResize() {
	if (resizeHandler && typeof window !== 'undefined') {
		window.removeEventListener('resize', resizeHandler)
		window.removeEventListener('orientationchange', resizeHandler)
	}
	if (vvHandler && window.visualViewport) {
		window.visualViewport.removeEventListener('resize', vvHandler)
		window.visualViewport.removeEventListener('scroll', vvHandler)
	}
	if (mapStageResizeObserver) {
		mapStageResizeObserver.disconnect()
		mapStageResizeObserver = null
	}
	resizeHandler = null
	vvHandler = null
}
